var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Search/searchSource.ts";
import { createEvent, restore } from 'effector';
export function createSearchSource() {
  var setSearchSourceData = createEvent({
    name: "setSearchSourceData",
    sid: "m0id77"
  });
  var searchSourceData$ = restore(setSearchSourceData, null, {
    name: "searchSourceData$",
    sid: "-qstasv"
  });
  return {
    setSearchSourceData: setSearchSourceData,
    searchSourceData$: searchSourceData$
  };
}